module.exports = __webpack_public_path__ + "static/media/重置密码.de8c9f7b.svg";